import { useTheme } from '@chakra-ui/react'
import * as R from 'ramda'

export const useThemeColor = (colorKey: string | undefined) => {
  const theme = useTheme()
  const colorPath = colorKey?.split('.')

  const color: string | undefined = colorPath
    ? R.path(['colors', ...colorPath], theme)
    : undefined

  return color
}
